import { Component } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { NOMBRE_SISTEMA } from "../environments/environment";
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {


  constructor(private readonly titleService: Title, private readonly matIconRegistry: MatIconRegistry, private readonly domSanitizer: DomSanitizer) {
    this.matIconRegistry.addSvgIcon(`broom-custom`, this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/broom-custom.svg"));
  }

  ngOnInit() {
    this.titleService.setTitle(NOMBRE_SISTEMA);
  }
}
